import { Inject, Injectable } from "@angular/core";
import { AuthService, JwtAuthService } from "@mydocma/auth";
import { BimViewerOptions } from "@mydocma/bim-viewer";
import { BP_CONFIG, BpConfig } from "../../config/bp.config";

@Injectable()
export class BimViewerOptionsFactory {


  private readonly jwtAuthService: JwtAuthService;
  private readonly bpApiUrl:  string;
  constructor(
    readonly authService: AuthService,
    @Inject(BP_CONFIG) readonly bpConfig: BpConfig){

    this.bpApiUrl = `${bpConfig.apiUrl}`

    this.jwtAuthService = this.authService as any as JwtAuthService;
  }

  public createOptions(): BimViewerOptions {
    return {
      getItemApi: this.getItemApi.bind(this),
      getManifestApi: this.getManifestApi.bind(this),
      authentication: { getAccessToken: this.getToken.bind(this) },
      hideToolbar: true
    }
  }

  private getToken() {
    return this.jwtAuthService.getAccessToken();
  }

  private getManifestApi(params: any) {
    const {bimModelId, id} = params;
    return `${this.bpApiUrl}forge/bim-models/${bimModelId}/versions/${id}/manifest`;
  };
  public getTileUrl(url: string): string {
    return `${url}?token=${this.jwtAuthService.getAccessToken()}`;
  }

  public getItemApi(params: any): string {
    const {bimModelId, id} = params.bimModel;
    return `${this.bpApiUrl}forge/bim-models/${bimModelId}/versions/${id}/files` + decodeURIComponent(params.derivativeUrn.split('output')[1] + '?token=' + params.accessToken);

  }



}
